import "./assets/fonts/Avenir-Roman-12.ttf";

import { getManifestFile, getBlankManifest, getBlankHTML } from "./Utilities";
import { getHTMLFile } from "./TemplateFactory";
import ConfirmationScreen from "./ConfirmationScreen";

import React, { useEffect, useState } from "react";
import "./nav.css";
import "./productPages/pageAndProductContainers.css"; //* moved here from PageElevator PageLFD PagePFD, allows Direct.js and Programmatic.js to sorta 'switch' which style were using
import JSZip from "jszip";
import { saveAs } from "file-saver";

import PageElevator from "./pages/PageElevator";
import PageLFD from "./pages/PageLFD";
import PagePFD from "./pages/PagePFD";
import Inputs from "./pages/Inputs";
import Results from "./pages/Results";
import Filename from "./Filename";
import WarningMessage from "./WarningMessage";
import DATA_PRODUCTS from "./DATA_PRODUCTS";
import { BlackWhiteToggleButton, ContinueButton, BackButton } from "./Buttons";

// import { useScreenshot } from "use-screenshot-hook";
import * as htmlToImage from "html-to-image";
import { toPng } from "html-to-image";

import PopUp from "./PopUp";

import CssBaseline from "@material-ui/core/CssBaseline";

import OpacityContext from "./OpacityContext";

export default function Direct({ onBackToLanding }) {
  const [bintBGOpacity, setBintBGOpacity] = useState(1);
  // for screen shots
  //const imageRef = useRef(null);
  const [screenshot, setScreenshot] = useState(); // 2

  const [continueButtonDisabled, setContinueButtonDisabled] = useState(false);
  // increases as user hits continue
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  // nav while dropping files 1 or 2 for l p.
  const [currentBuildNavNumber, setCurrentBuildNavNumber] = useState(1);

  const [productIndex, setProductIndex] = useState(4);
  const [inputsCheckButtonPressed, setInputsCheckButtonPressed] = useState(
    false
  );
  const [
    inputsCheckButtonPressedOnce,
    setInputsCheckButtonPressedOnce
  ] = useState(false);

  const [isElevator, setIsElevator] = useState(true);
  const [requiresBlankFile, setRequiresBlankFile] = useState(false);
  const [warningMessageText, setWarningMessageText] = useState("");
  const [
    warningMessageTextShowIcon,
    setWarningMessageTextShowIcon
  ] = useState();

  const [inputValues, setInputValues] = useState({
    client: "",
    campaign: ""
    // product: "",
    // duration: "",
    // countryCode: "",
  });
  const [showPopUp, setShowPopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState("test message");

  const [bintBGColor, setBintBGColor] = useState("000000");
  const [defaultBintBGColor, setDefaultBintBGColor] = useState(false);

  const [shakeDropzoneBGImage, setShakeDropzoneBGImage] = useState(false);

  const [filename, setFilename] = useState();
  const [blankFilename, setBlankFilename] = useState();

  // dropped images and video files
  const [elevatorFile, setElevatorFile] = useState({}); // 12
  const [lfdFile, setLfdFile] = useState({}); // 13
  const [pfdFile, setPfdFile] = useState({}); // 14
  const [svgFile, setSvgFile] = useState({}); // 15
  const [standardAdFile, setStandardAdFile] = useState({}); // 16

  const [mediaExtensions, setMediaExtensions] = useState({}); // 17
  // const [lobbyAndOneAsset, setLobbyAndOneAsset] = useState(); //29
  // const [lobbyAndOneAssetIsLFD, setLobbyAndOneAssetIsLFD] = useState(); //30

  // const [elevatorFileError, setElevatorFileError] = useState(false);
  // const [lfdFileError, setLfdFileError] = useState(false);
  // const [pfdFileError, setPfdFileError] = useState(false);
  // const [svgFileError, setSvgFileError] = useState(false);
  // const [standardAdFileError, setStandardAdFileError] = useState(false);

  const [allDroppedFilenames, setAllDroppedFilenames] = useState([]);
  const [allDroppedNewFilenames, setAllDroppedNewFilenames] = useState([]);

  const [mediaExtension, setMediaExtension] = useState();

  const [noBintImages, setNoBintImages] = useState(false);
  const [isBlackText, setIsBlackText] = useState(false);

  // Helper to check if droppedFileType is any SVG type
  const isSVGType = type =>
    ["svg", "svg-landscape", "svg-portrait"].includes(type);

  const handleWarningMessageText = (txt, showIcon) => {
    setWarningMessageText(txt);
    setWarningMessageTextShowIcon(showIcon);
  };

  const handleBackPopUpPress = () => {
    // this only shows from Preview to Results so just set number to 2
    setCurrentPageNumber(2);
    setShowPopUp(false);
    setPopUpMessage("");
  };

  const handleContinueButtonDisabled = bool => {
    setContinueButtonDisabled(bool);
  };

  const handleContinuePopUpPress = () => {
    // this runs when just 1 asset dropped
    // setLobbyAndOneAsset(true);
    // handle mediaExtensions state.
    if (mediaExtensions.landscape) {
      // setLobbyAndOneAssetIsLFD(true);
      const newExtension = mediaExtensions.landscape;
      setMediaExtensions(prevState => ({
        ...prevState,
        portrait: newExtension
      }));
    } else {
      //  setLobbyAndOneAssetIsLFD(false);
      const newExtension = mediaExtensions.portrait;
      setMediaExtensions(prevState => ({
        ...prevState,
        landscape: newExtension
      }));
    }

    setShowPopUp(false);
    setPopUpMessage("");
    okToGoToPageThree();
  };

  // this is called when arriving at Results page (4).  Sets filename and blank filename
  // also used when compiling list of input files and their new names
  const getFilename = () => {
    const productNumber = parseInt(inputValues.product);
    const clientName = inputValues.client;
    const duration = inputValues.duration;
    const desc = inputValues.campaign;
    const countryCode = inputValues.countryCode;
    const eORl = inputValues.platform === "elevator" ? "e" : "l";
    const fsValue = DATA_PRODUCTS.data[productNumber].isFS ? "_fs" : "";
    const product = DATA_PRODUCTS.data[productNumber].label;

    try {
      setBlankFilename(
        `${clientName}_${duration}_${product}blank_${countryCode}${fsValue}_${eORl}-${product}`
      );
    } catch {
      console.log("not yet");
    }
    return `${clientName}_${duration}_${desc}_${countryCode}${fsValue}_${eORl}-${product}`;
  };

  const getNewNameForDroppedFile = (filenameString, typeString) => {
    console.log(
      `d101 running, what is filenameString(${filenameString}) and typeString(${typeString})`
    );
    const eORl = inputValues.platform === "elevator" ? "e" : "l";

    const baseFilename = getFilename(
      inputValues,
      eORl,
      DATA_PRODUCTS.data[productIndex].label
    );

    // all you are doing here is grabbing the extension.
    // namesplit[length]

    const nameSplit =
      typeof filenameString === "undefined" ? "" : filenameString.split(".");
    const ext = nameSplit[nameSplit.length - 1];
    console.log("d101 nameSplit = ", nameSplit);
    const videoOrImageString = ext === "mp4" ? "video" : "image";
    let returnValue = "";

    if (typeof filenameString === "undefined") {
      returnValue = undefined;
    } else if (typeString === "svg") {
      returnValue = `${baseFilename}.${ext}`;
    } else if (typeString === "standardAd") {
      returnValue = `${baseFilename}.${ext}`;
    } else if (typeString === "p") {
      returnValue = `${baseFilename}_p${videoOrImageString}.${ext}`;
    } else {
      returnValue = `${baseFilename}_${eORl}${videoOrImageString}.${ext}`;
    }

    return returnValue;
  };

  // these functions are called when landing on the Results page.
  // they make the arrays that display in the text areas that show filed received and to be delivered
  // Keep in mind, these are not the same file names that are used to create the files put in the zip file.
  // these are just for display.
  // creates an array of all the new file names of files that were dropped

  const getAllDroppedNewFilenames = () => {
    return [
      getNewNameForDroppedFile(elevatorFile.name, "e"),
      getNewNameForDroppedFile(lfdFile.name, "l"),
      getNewNameForDroppedFile(pfdFile.name, "p"),
      getNewNameForDroppedFile(svgFile.name, "svg"),
      getNewNameForDroppedFile(standardAdFile.name, "standardAd")
    ];
  };
  // creates an array of all names of files that were dropped.
  const getAllDroppedFilenames = () => {
    return [
      elevatorFile.name,
      lfdFile.name,
      pfdFile.name,
      svgFile.name,
      standardAdFile.name
    ];
  };
  ////////////////////////////////////////////////////////

  const handleBackButton = () => {
    if (currentPageNumber > 1 && currentPageNumber < 4) {
      setCurrentPageNumber(currentPageNumber - 1);
    } else if (
      currentPageNumber === 1 &&
      typeof onBackToLanding === "function"
    ) {
      onBackToLanding();
    }
  };

  const circleButtonClickHandler = e => {
    const numberValue = parseInt(e.target.attributes.dataindex.value);
    setCurrentPageNumber(numberValue);
  };

  const handleELPNavClick = e => {
    const val = parseInt(e.target.dataset.value);
    setCurrentBuildNavNumber(val);
  };
  function onlyLettersAndNumbers(str) {
    return /^[A-Za-z0-9-]*$/.test(str);
  }

  const takeScreenshot = () => {
    console.log("taking screenshot");
    // the only place that this function is called is when there are no errors
    // on page 2 and it is time to go to page 3.  Because of this it is ok
    // to have a useEffect for state value SCREENSHOT.  When it changes, go to page 3
    // but unfortunately when moving back from 3 to 2 with numubers button and then
    // not changing the image means that the screen shot will be retaken but not changed
    // because the image taken is the same as the previous one.  This is fixed by adding
    // a random number to the screenshot state so it changes with every update
    htmlToImage
      .toPng(document.getElementById("screenGrabThis"))
      .then(function(dataUrl) {
        let randomValue = Math.random();
        setScreenshot([dataUrl, randomValue]);
      })
      .catch(() => {
        console.log("there was an error");
      });
  };

  const hexColorRegex = /^#([A-Fa-f0-9]{6})$/;

  const handleContinueButtonPressed = () => {
    setInputsCheckButtonPressedOnce(true);
    switch (currentPageNumber) {
      case 1:
        handlePage1Continue();
        break;
      case 2:
        handlePage2Continue();
        break;
      case 3:
        deliverTemplateFiles();
        break;
      case 4:
        resetStateToBeginning();
        break;
      default:
        break;
    }
  };

  const handlePage1Continue = () => {
    // moving from inputs to Elevator or LFD
    // check if all values filled in
    if (
      inputValues.client &&
      inputValues.campaign &&
      onlyLettersAndNumbers(inputValues.client) &&
      onlyLettersAndNumbers(inputValues.campaign) &&
      inputValues.product !== undefined &&
      inputValues.countryCode &&
      inputValues.platform &&
      inputValues.duration
    ) {
      handleWarningMessageText("", false);
      setInputsCheckButtonPressed(false);
      setCurrentPageNumber(2);
      handleWarningMessageText("drag and drop or click for upload", false);
    } else {
      handleWarningMessageText("input not complete.", true);
      setInputsCheckButtonPressed(true);
      // set back to false so that error animations will play again
      setTimeout(() => {
        setInputsCheckButtonPressed(false);
      }, "2000");
    }
  };
  const handlePage2Continue = () => {
    // this runs when landing on the RESULTS  page.
    // check if all dropboxes have been filled
    // check if proper files dropped
    const missingFilesArray = [];
    const validateFile = (file, fileName) => {
      if (!file.payload) {
        setShakeDropzoneBGImage(true);
        setTimeout(() => setShakeDropzoneBGImage(false), 2000);
        missingFilesArray.push(fileName);
        return 1;
      }
      return 0;
    };

    let checkErrors = 0;

    if (!hexColorRegex.test("#" + bintBGColor)) {
      handleWarningMessageText("Please enter a valid 6-digit hex color.", true);
      return; // Exit early if hex color is invalid
    } else if (noBintImages) {
    } else if (isElevator) {
      checkErrors += validateFile(elevatorFile, "elevator");
    } else if (isElevator) {
      checkErrors += validateFile(elevatorFile, "elevator");
    } else {
      checkErrors += validateFile(lfdFile, "lfd");
      checkErrors += validateFile(pfdFile, "pfd");
    }

    // check for svg
    if (inputValues.product === 4) {
      checkErrors += validateFile(svgFile, "svg");
      // Ensure mediaExtensions.svg is set
      if (!mediaExtensions.svg && svgFile.name) {
        const splitValue = svgFile.name.split(".");
        setMediaExtensions(prevState => ({
          ...prevState,
          svg: splitValue[splitValue.length - 1]
        }));
      }
    }

    if (checkErrors === 0) {
      okToGoToPageThree();
    } else if (
      !isElevator &&
      (inputValues.product === 1 || inputValues.product === 3) &&
      checkErrors === 1
    ) {
      // lfsa or lvsa and 1 error, show overlay
      setShowPopUp(true);
      setPopUpMessage(
        "The same asset will be used for both landscape and portrait."
      );
    } else {
      // elevator or lobby bint, lobby hfsp, lobby fsbi and errors > 0,
      // show the error text
      handleWarningMessageText(`files missing: ${missingFilesArray}`, true);
    }
  };
  const okToGoToPageThree = () => {
    handleWarningMessageText("", false);
    // this sets filename and blank filename
    setFilename(getFilename);
    const productNumber = parseInt(inputValues.product);
    setRequiresBlankFile(DATA_PRODUCTS.data[productNumber].requiresBlankFile);

    setAllDroppedFilenames(getAllDroppedFilenames);

    setAllDroppedNewFilenames(getAllDroppedNewFilenames); //* this is the d101 block of code

    // there is a bug.  when using the number buttons to return from pg
    // 3 to 2 and then hitting continue again, user can't get to page 3
    // because you only go to page 3 after screenshot changes.  by not dropping
    // a new file, screenshot does not change.  it just takes an image of the
    // same div
    takeScreenshot();
    //
  };
  useEffect(() => {
    console.log("screenshot changed");
    if (currentPageNumber === 2) {
      setCurrentPageNumber(3);
    }
  }, [screenshot]);

  const resetStateToBeginning = () => {
    window.location.reload();
  };

  // runs when product changes to set productIndex, isElevator, isFullScreen
  const effectHandleProductChange = () => {
    setProductIndex(inputValues.product);
    // clear all files and previews
    setElevatorFile({});
    setLfdFile({});
    setPfdFile({});
    setSvgFile({});
    setStandardAdFile({});
    console.log(
      `effectHandleProductChange is now setProductIndex to equal inputValues.product[${inputValues.product}`
    );
  };

  useEffect(() => {
    effectHandleProductChange();
  }, [inputValues.product, inputValues.platform]);

  // runs when product changes to set productIndex, isElevator, isFullScreen
  const effectHandlePlatformChange = () => {
    // clear all files and previews
    setElevatorFile({});
    setLfdFile({});
    setPfdFile({});
    setSvgFile({});
    setStandardAdFile({});
  };

  // handler for all inputs
  const handleAnyInputsChange = (name, value) => {
    // if this is setting elevator or lobby, change currentAdBuildingPageNumber to show either elev or lfp
    if (name === "platform") {
      if (value === "elevator") {
        setIsElevator(true);
      } else {
        setIsElevator(false);
      }
    }

    setInputValues(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  /////////////////////////////////////////////////

  const handleDropzoneChanges = (name, value, droppedFileType) => {
    console.log(
      "Direct handleDropzoneChanges, isSVGType(droppedFileType)",
      isSVGType(droppedFileType)
    );

    // droppedFileType = elevator, landscape, portrait, svg, standardAd
    // if (droppedFileType === "svg") {
    if (isSVGType(droppedFileType)) {
      setSvgFile(prevState => ({
        ...prevState,
        [name]: value
      }));
    } else if (droppedFileType === "standardAd") {
      console.log("setting standard ad");
      setStandardAdFile(prevState => ({
        ...prevState,
        [name]: value
      }));
    } else if (droppedFileType === "elevator") {
      setElevatorFile(prevState => ({
        ...prevState,
        [name]: value
      }));
    } else if (droppedFileType === "landscape") {
      setLfdFile(prevState => ({
        ...prevState,
        [name]: value
      }));
    } else if (droppedFileType === "portrait") {
      setPfdFile(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
    // svg, standardAd, elevator, landscape, portrait
    if (name === "name") {
      console.log("Direct running split");
      const splitValue = value.split(".");
      setMediaExtensions(prevState => ({
        ...prevState,
        [droppedFileType]: splitValue[splitValue.length - 1]
      }));
    }
  };

  ///////////////////////////////////////////////
  // * zip 'em up

  const deliverTemplateFiles = () => {
    // const eORl = isElevator ? "e" : "l";

    //const finalStandardAdFilename = `${inputValues.client}_${inputValues.duration}_${inputValues.campaign}_${inputValues.countryCode}_${eORl}-stnd`;

    console.log("deliverTemplateFiles()");
    console.log(" ------------------->> what is filename:", filename);
    console.log(
      " ------------------->> what is mediaExtensions:",
      mediaExtensions
    ); //* undefined, and irrelevant to what we are zipping
    console.log(
      " ------------------->> what is mediaExtensions.elevator:",
      mediaExtensions.elevator
    ); //* undefined, and irrelevant to what we are zipping

    // HTML file
    // valH is the text of the html template passed from TemplateCreator
    let contentH = getHTMLFile(
      filename,
      isElevator,
      mediaExtensions,
      productIndex,
      bintBGColor,
      isBlackText,
      noBintImages,
      defaultBintBGColor
    );
    let blobH = new Blob([contentH], {
      type: "text/plain;charset=utf-8"
    });

    // manifest file
    //valM is the text of the manifest template passed from TemplateCreator
    var contentM = getManifestFile(
      noBintImages,
      filename,
      isElevator,
      mediaExtensions,
      false
    );
    var blobM = new Blob([contentM], {
      type: "text/plain;charset=utf-8"
    });

    ///////////////////////////////////////
    // if blank file
    let blobBH;
    let blobBM;

    if (requiresBlankFile) {
      // blank HTML file
      let contentBH = getBlankHTML(blankFilename);
      blobBH = new Blob([contentBH], {
        type: "text/plain;charset=utf-8"
      });

      // blank manifest file
      var contentBM = getBlankManifest(blankFilename);
      blobBM = new Blob([contentBM], {
        type: "text/plain;charset=utf-8"
      });
    }
    ///////////////////////////////////////
    // at this point all the manifests are done. Now you need to
    // do the async stuff like loading images and videos

    let newZip = new JSZip();
    newZip.file(`${filename}.html`, blobH);
    newZip.file(`${filename}.manifest`, blobM);

    const loadElevator = elevatorFile.payload
      ? elevatorFile.payload.arrayBuffer().then(result => {
          newZip.file(
            `${filename}_e${
              mediaExtensions.elevator === "mp4" ? "video" : "image"
            }.${mediaExtensions.elevator}`,
            result
          );
        })
      : "";

    // if this is a lobby 1 file and the source is a pfd, pfd is the source
    // else, lfd is the source
    //const lfdSource = lobbyAndOneAsset && lobbyAndOneAssetIsLFD === false ? pfdFile : lfdFile;
    // i think this will be fine because you no longer have any situation where lfd or pfd are empty
    const loadLFD = lfdFile.payload
      ? lfdFile.payload.arrayBuffer().then(result => {
          newZip.file(
            `${filename}_l${
              mediaExtensions.landscape === "mp4" ? "video" : "image"
            }.${mediaExtensions.landscape}`,
            result
          );
        })
      : "";

    //const pfdSource = lobbyAndOneAsset && lobbyAndOneAssetIsLFD ? lfdFile : pfdFile;
    const loadPFD = pfdFile.payload
      ? pfdFile.payload.arrayBuffer().then(result => {
          newZip.file(
            `${filename}_p${
              mediaExtensions.portrait === "mp4" ? "video" : "image"
            }.${mediaExtensions.portrait}`,
            result
          );
        })
      : "";

    const loadSVG = svgFile.payload
      ? svgFile.payload.arrayBuffer().then(result => {
          newZip.file(`${filename}.svg`, result);
        })
      : "";

    // const loadStandardAd = standardAdFile.payload
    //   ? standardAdFile.payload.arrayBuffer().then((result) => {
    //       newZip.file(`${finalStandardAdFilename}.mp4`, result);
    //     })
    //   : "";

    const loadObject = [
      { file: elevatorFile, fn: loadElevator },
      { file: lfdFile, fn: loadLFD },
      { file: pfdFile, fn: loadPFD },
      { file: svgFile, fn: loadSVG }
      // { file: standardAdFile, fn: loadStandardAd },
    ];
    const promiseArray = loadObject.map(obj => {
      if (obj.file.payload) {
        return obj.fn;
      } else return null;
    });

    Promise.all(promiseArray)
      .then(e => {
        if (requiresBlankFile) {
          newZip.file(`${blankFilename}.html`, blobBH);
          newZip.file(`${blankFilename}.manifest`, blobBM);
        }

        newZip.generateAsync({ type: "blob" }).then(function(content) {
          saveAs(content, `${filename}.zip`);
        });
      })
      .then(e => {
        console.log("finished");
        // if success, show final screen
        // final screen will always say 'downloading' and no way to see when finished.
        setCurrentPageNumber(4);
      })
      .catch(e => {
        console.log("zip error");
      });
  };

  // next step is to set opacity to .5 when setting to default background
  // and setting back to 1 when unsetting default bg

  const handleBINTColorChange = color => {
    // Allow only hex characters (0-9, a-f, A-F)
    const sanitizedColor = color.replace(/[^0-9a-fA-F]/g, "");
    setBintBGColor(sanitizedColor);
    // still need to only allow 6 character colors.
    // probably need to separate the characters shown (not valid colors)
    // and the actual color.  On 6 characters set actual color.  but as you
    // get to 6, show the hex only characters.
  };
  const handleBlackWhiteToggleChange = () => {
    setIsBlackText(prevIsBlackText => !prevIsBlackText);
  };
  const handleNoImagesToggleChange = () => {
    setNoBintImages(prevNoBintImages => !prevNoBintImages);
    // clear out all dropped images
    effectHandlePlatformChange();
    setElevatorFile({});
    setLfdFile({});
    setPfdFile({});

    // clear out dropzoneImageParent
    const eToClear = document.querySelector(".ebintAd .dropzoneImageParent");
    const lToClear = document.querySelector(".lBintAd .dropzoneImageParent");
    const pToClear = document.querySelector(".pBintAd .dropzoneImageParent");

    while (eToClear.firstChild) {
      eToClear.removeChild(eToClear.lastChild);
    }
    while (lToClear.firstChild) {
      lToClear.removeChild(lToClear.lastChild);
    }
    while (pToClear.firstChild) {
      pToClear.removeChild(pToClear.lastChild);
    }
  };
  const handleDefaultBintBGColorChange = () => {
    console.log("changed");

    defaultBintBGColor ? setBintBGOpacity(1) : setBintBGOpacity(0.2);
    setDefaultBintBGColor(prevDefaultBintBGColor => !prevDefaultBintBGColor);
    setIsBlackText(false);
    setBintBGColor("000000");
  };

  return (
    <div className="directLayout appContainer flexColumnCenterClass">
      <div className="topSub">
        {currentPageNumber !== 4 ? (
          <Filename inputValues={inputValues} />
        ) : null}
      </div>
      <div className="contentSub">
        {/* PAGE 1 */}
        {/* {`adBuildingPageInner ${currentBuildNavNumber === 2 ? "hide" : ""}`} */}

        {currentPageNumber !== 4 ? (
          <div
            className={`inputsPage page ${
              currentPageNumber !== 1 ? "hide" : ""
            }`}
          >
            <Inputs
              productIndex={productIndex}
              inputValues={inputValues}
              handleAnyInputsChange={handleAnyInputsChange}
              inputsCheckButtonPressed={inputsCheckButtonPressed}
              inputsCheckButtonPressedOnce={inputsCheckButtonPressedOnce}
            />
          </div>
        ) : null}

        {/* PAGE 2 */}

        {/* when this classname is set to e l or p, that's what sets the h and w of the div which contains all building elements*/}
        <OpacityContext.Provider
          value={{
            bintBGOpacity,
            isBlackText,
            noBintImages,
            bintBGColor,
            productIndex,
            svgFile,
            shakeDropzoneBGImage,
            elevatorFile,
            lfdFile,
            pfdFile,
            setLfdFile,
            setPfdFile
          }}
        >
          {/* elevator */}
          <div
            id={isElevator ? "screenGrabThis" : null}
            className={`adBuildingPageInner ${
              currentPageNumber === 2 && isElevator ? "" : "hide"
            }`}
          >
            <PageElevator
              handleDropzoneChanges={handleDropzoneChanges}
              handleWarningMessageText={handleWarningMessageText}
              handleContinueButtonDisabled={handleContinueButtonDisabled}
            />
          </div>

          {/* lfd */}
          <div
            id={isElevator ? null : "screenGrabThis"}
            className={`adBuildingPageInner ${
              currentPageNumber === 2 && isElevator === false ? "" : "hide"
            }`}
          >
            {/* <div
                  className={`adBuildingPageInner ${
                    currentBuildNavNumber === 2 ? "hide" : ""
                  }`}
                > */}
            <PageLFD
              handleDropzoneChanges={handleDropzoneChanges}
              handleWarningMessageText={handleWarningMessageText}
              handleContinueButtonDisabled={handleContinueButtonDisabled}
            />
            {/* </div> */}

            {/* pfd */}
            {/* <div
                  className={`adBuildingPageInner ${
                    currentBuildNavNumber === 1 ? "hide" : ""
                  }`}
                > */}
            <PagePFD
              handleDropzoneChanges={handleDropzoneChanges}
              handleWarningMessageText={handleWarningMessageText}
              handleContinueButtonDisabled={handleContinueButtonDisabled}
            />
            {/* </div> */}
          </div>
        </OpacityContext.Provider>

        {/* this was .adBuildingPageContent .elevator OR .lfdANDpfdContainer*/}
        {/* </div> */}

        {/* this was .adBuildingPage .page */}
        {/* </div> */}

        {/* {currentPageNumber !== 4 ? backButton : null} */}
        {currentPageNumber !== 4 ? (
          <BackButton handleBackButton={handleBackButton} />
        ) : null}

        {/* PAGE 3 */}
        <div
          className={`resultsPage page ${
            currentPageNumber !== 3 ? "hide" : ""
          }`}
        >
          <Results
            allDroppedFilenames={allDroppedFilenames}
            allDroppedNewFilenames={allDroppedNewFilenames}
            filename={filename}
            blankFilename={blankFilename}
            requiresBlankFile={requiresBlankFile}
            bintBGColor={bintBGColor}
            productIndex={productIndex}
            isBlackText={isBlackText}
            inputValues={inputValues}
            screenshot={screenshot}
            elevatorFile={elevatorFile}
            standardAdFile={standardAdFile}
            lfdFile={lfdFile}
            pfdFile={pfdFile}
          />
        </div>
      </div>

      <div className="navSubSticky">
        <div className="navSub flexColumnCenterClass">
          {currentPageNumber !== 4 ? (
            <WarningMessage
              warningMessageText={warningMessageText}
              warningMessageTextShowIcon={warningMessageTextShowIcon}
            />
          ) : null}
          {/* BINT buttons, moved here from TopSub */}
          {currentPageNumber === 2 && inputValues.product === 0 ? (
            <BlackWhiteToggleButton
              handleDefaultBintBGColorChange={handleDefaultBintBGColorChange}
              handleBINTColorChange={handleBINTColorChange}
              isBlackText={isBlackText}
              noBintImages={noBintImages}
              defaultBintBGColor={defaultBintBGColor}
              bintBGColor={bintBGColor}
              handleBlackWhiteToggleChange={handleBlackWhiteToggleChange}
              handleNoImagesToggleChange={handleNoImagesToggleChange}
            >
              {" "}
            </BlackWhiteToggleButton>
          ) : null}

          {currentPageNumber !== 4 ? (
            <div className="buttonsHolder">
              <div
                onClick={circleButtonClickHandler}
                dataindex={1}
                className={`circleButton ${
                  currentPageNumber === 1 ? "current" : "enabled"
                }`}
              >
                1
              </div>
              <div
                onClick={circleButtonClickHandler}
                dataindex={2}
                className={`circleButton ${
                  currentPageNumber === 2
                    ? "current"
                    : currentPageNumber > 2
                    ? "enabled"
                    : "disabled"
                }`}
              >
                2
              </div>
              <div
                onClick={circleButtonClickHandler}
                dataindex={4}
                className={`circleButton ${
                  currentPageNumber === 3 ? "current" : "disabled"
                }`}
              >
                3
              </div>
            </div>
          ) : null}

          <ContinueButton
            currentPageNumber={currentPageNumber}
            handleContinueButtonPressed={handleContinueButtonPressed}
            continueButtonDisabled={continueButtonDisabled}
          ></ContinueButton>
        </div>
      </div>
    </div>
  );
}
